import React from 'react';
import { PrinterIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { BoardMotif } from './BoardMotif';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-navy" data-id="element-24" data-mp="plsjs38jiy8p">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-25" data-mp="autg96mkazvz">
        <div className="text-center" data-id="element-26" data-mp="ftej7dt77xo4">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-27" data-mp="fsbn8rh0r51c">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="chalk-underline mt-3 font-display text-white text-[28px] sm:text-5xl" data-id="element-28" data-mp="5wi4gqcpifb4">
            Five instant-use <span className="text-gold" data-id="element-29" data-mp="3o3y4rpxfyy6j">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/75" data-id="element-30" data-mp="3t1835v2t6k6i">
            The volumes give you the season. These five get you teaching from
            it before your next meeting — so nothing sits unopened.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-31" data-mp="3ieg5kyb27wy7">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`clip-corner flex flex-col overflow-hidden rounded-2xl border border-navy-line bg-navy-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-32" data-mp="3dfd57r60yewk" data-mpi={i}>
              {bonus.cover ? <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="aspect-square w-full border-b border-navy-line object-cover" data-id="element-33" data-mp="2zhogg88u6nm8" /> : <div className="relative flex aspect-[16/9] w-full flex-col justify-end overflow-hidden border-b border-navy-line bg-ice p-5 text-ink" data-id="element-34" data-mp="nprjn758onkm">
                  <BoardMotif className="pointer-events-none absolute -right-6 -top-6 h-40 w-40 text-ink/[0.08]" data-id="element-35" data-mp="iqewelaghehi" />
                  <span className="absolute left-5 top-5 rounded bg-navy px-2 py-1 text-[10px] font-bold uppercase tracking-widest text-gold" data-id="element-36" data-mp="3cl0t523cs8gs">
                    Bonus {bonus.number}
                  </span>
                  <span className="relative font-display text-xl leading-tight" data-id="element-37" data-mp="3lhrxs2vz0vmz">
                    {bonus.title}
                  </span>
                  <span className="relative mt-2 flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-gold-deep" data-id="element-38" data-mp="2tt7zd5ggmj80">
                    <PrinterIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-39" data-mp="2xua23w9l5deq" />
                    {bonus.meta}
                  </span>
                </div>}
              <div className="px-5 pb-6 pt-4" data-id="element-40" data-mp="37kv7q3nofi75">
                <div className="flex flex-wrap items-center gap-2" data-id="element-41" data-mp="37lo8mnzyfdhd">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-white/60" data-id="element-42" data-mp="2a3wimu52gmvr">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded bg-gold px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-gold-ink" data-id="element-43" data-mp="27kjaisdvi1ik">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 text-lg font-bold leading-snug text-white" data-id="element-44" data-mp="1xl2aaqhe4ftz">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-white/70" data-id="element-45" data-mp="1tjp0y6f39uib">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}